import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { F_NUM, F_STR } from 'assets/FormatNumbers'
import { select } from 'types/SearchTypes'
import { response } from 'utils/apiUtil'
import { responseTokuiTen } from 'utils/requestUtil'

type ModalUserState = {
  TOKUI_CD: number // 得意先コード
  TOKUI_NM: string // 得意先名
  TOKUI_NM_ERROR: boolean // 得意先名取得判定
  TEN_CD: number // 店舗コード
  TEN_NM: string // 店舗名
  TEN_NM_ERROR: boolean // 店舗名取得判定
  MAIL: string // メールアドレス
  NAME: string // 氏名
  NAME_ERROR: boolean // 氏名取得判定
  tokuiList: select[] // モーダルを開いた時点の得意先リスト
  tenList: select[] // モーダルを開いた時点の店舗リスト
}

const initialState: ModalUserState = {
  TOKUI_CD: F_NUM, // 得意先コード
  TOKUI_NM: F_STR, // 得意先名
  TOKUI_NM_ERROR: false, // 得意先名取得判定
  TEN_CD: F_NUM, // 店舗コード
  TEN_NM: F_STR, // 店舗名
  TEN_NM_ERROR: false, // 店舗名取得判定
  MAIL: F_STR, // メールアドレス
  NAME: F_STR, // 氏名
  NAME_ERROR: false, // 氏名取得判定
  tokuiList: [],
  tenList: [],
}
export const ModalUserSlice = createSlice({
  name: 'ModalUser',
  initialState: initialState,
  reducers: {
    // メールアドレスを変更 //===========================//
    changeMail: (state, action: PayloadAction<string>) => {
      state.MAIL = action.payload
    },
    //  得意先コードを変更 //===========================//
    changeTokuiCode: (state, action: PayloadAction<number>) => {
      state.TOKUI_CD = action.payload
    },
    //  店舗コードを変更 //===========================//
    changeTenCode: (state, action: PayloadAction<number>) => {
      state.TEN_CD = action.payload
    },
    // API取得した得意先・店舗情報を反映 //===========================//
    changeTokuiTen: (state, action: PayloadAction<response<responseTokuiTen>>) => {
      const payload = action.payload
      if (!payload.error) {
        state.TOKUI_NM = payload.body.TOKUI_NM
        state.TEN_NM = payload.body.TEN_NM
        state.TOKUI_NM_ERROR = payload.alert
        state.TEN_NM_ERROR = payload.alert
      } else {
        // 異常発生時
        state.TOKUI_NM = 'エラー' // 固定メッセージはマスタメッセージと違う文言にしておく(この文字が見えたらシステムエラー)
        state.TEN_NM = 'エラー'
        state.TOKUI_NM_ERROR = true
        state.TEN_NM_ERROR = true
      }
    },
    // API取得した氏名情報を反映 //===========================//
    changeName: (state, action: PayloadAction<response<{ NAME: string }>>) => {
      const payload = action.payload
      if (!payload.error) {
        state.NAME = payload.body.NAME
        state.NAME_ERROR = payload.alert
      } else {
        // 異常発生時
        state.NAME = 'エラー' // 固定メッセージはマスタメッセージと違う文言にしておく(この文字が見えたらシステムエラー)
        state.NAME_ERROR = true
      }
    },
    //  得意先リストを変更 //===========================//
    changeTokuiList: (state, action: PayloadAction<select[]>) => {
      state.tokuiList = action.payload
    },
    //  店舗リストを変更 //===========================//
    changeTenList: (state, action: PayloadAction<select[]>) => {
      state.tenList = action.payload
    },
    // 初期化 //===========================//
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof ModalUserState = key as keyof ModalUserState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  changeName, // 氏名を変更
  changeMail, // メールアドレスを変更
  changeTokuiCode, // 得意先コードを変更
  changeTenCode, // 店舗コードを変更
  changeTokuiTen, // API取得した得意先・店舗情報を反映
  changeTokuiList, // 得意先リストを変更
  changeTenList, // 店舗リストを変更
  format, // 初期化
} = ModalUserSlice.actions
export default ModalUserSlice.reducer
